"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoPlayer = void 0;
const helpers_1 = require("../../../lib/helpers");
exports.videoPlayer = {
    playIconBackdropSize: (0, helpers_1.displayWidthToken)({
        0: 48,
        640: 82,
    }),
    playIconSize: (0, helpers_1.displayWidthToken)({
        0: "large",
        640: "jumbo",
    }),
    playIconBackdropOpacity: 0.5,
};
